import React, { ReactNode, useEffect } from 'react';
import { useAppSelector, useThunkDispatch } from '../../hooks/redux';

import { Route } from 'react-router-dom';
import auth from 'utils/auth';
import checkLogin from '../../actions/setters/checkLogin';
import config from 'config';
import useRedirectToCharityHome from '../../hooks/useRedirectToCharityHome';

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  exact,
  path,
}) => {
  const dispatch = useThunkDispatch();
  const redirectToCharityHome = useRedirectToCharityHome();
  const isLoggedIn = useAppSelector(state => state.app.loginStatus.isLoggedIn);
  const isOnlyCharity = auth.isCharity() && !auth.isConsumer();

  useEffect(() => {
    dispatch(checkLogin()).catch(() => {
      window.location.assign(
        `${config.loginUrl}&returnUrl=${window.location.href}`,
      );
    });
  }, []); // eslint-disable-line

  useEffect(() => {
    dispatch(() => {
      if (isLoggedIn && isOnlyCharity) redirectToCharityHome();
    });
  }, []); //eslint-disable-line

  return (
    <Route
      exact={exact}
      path={path}
      render={() => (isLoggedIn ? children : null)}
    />
  );
};

export interface PrivateRouteProps {
  children: ReactNode;
  path?: string;
  exact?: boolean;
}
